import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";

import StockTable from "./stock-table";
import SearchBar from "./search-bar";

export const Homepage = () => {
  const [stocks, setStocks] = useState();
  const fetchStocks = useCallback(async () => {
    const response = await axios.get("/api/most_expensive");
    setStocks(response?.data?.results);
  }, [setStocks]);
  useEffect(() => {
    fetchStocks();
  }, [fetchStocks]);

  const trackVisitedPatreon = useCallback(() => {
    ReactGA.event({
      category: "Conversion",
      action: "Visited Patreon from homepage",
    });
  }, []);

  return (
    <>
      <SearchBar />
      <h2>Welcome to IBorrow Desk</h2>
      <h4>Helping you track Interactive Brokers stock loan availability</h4>
      <p>
        If you haven't already, please consider{" "}
        <Link to="/register">registering </Link>
        or becoming a{" "}
        <a
          href="https://www.patreon.com/iborrowdesk"
          target="_blank"
          onClick={trackVisitedPatreon}
        >
          Patron
        </a>
        ! I'll really appreciate it!
      </p>
      <h4>America's most expensive borrows (excluding ADRs, debt)</h4>
      {stocks != null ? (
        <StockTable stocks={stocks} type="fee" showUpdated />
      ) : null}
    </>
  );
};
